import type { GroupedCodingResult } from 'src/types/dashboard';
import OpenCommentsTreeItem from 'src/components/dashboard/DashboardPage/widgets/OpenCommentsWidget/TreeItem';
import type { OpenCommentFilter } from 'src/components/dashboard/DashboardPage/widgets/OpenCommentsWidget/types';

import { styles } from './index.styles';

/**
 * Render open comments tree recursively.
 */
const renderTree = (
  topic: GroupedCodingResult,
  currentLevel: number,
  highestCount: number,
  question: string | null,
  openCommentFilter: OpenCommentFilter,
  design: 'default' | 'hrqs', // The HRQS widget has a different design but is functionally the same
  showTranslationToggle: boolean,
) => (
  <OpenCommentsTreeItem
    highestCount={highestCount}
    key={topic.label}
    level={currentLevel}
    itemId={topic.label}
    question={question}
    openCommentFilter={openCommentFilter}
    sx={currentLevel >= 1 ? styles.secondTreeItemLevel : null}
    treeData={topic}
    treeLabel={topic.label}
    treeLabelAddition={topic.topicLabel}
    design={design}
    showTranslationToggle={showTranslationToggle}
  >
    {Array.isArray(topic.subTopics) && openCommentFilter.topicFilter === 'all'
      ? topic.subTopics.map((topic) =>
          renderTree(
            topic,
            currentLevel + 1,
            highestCount,
            question,
            openCommentFilter,
            design,
            showTranslationToggle,
          ),
        )
      : null}
  </OpenCommentsTreeItem>
);

export default renderTree;
